import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const maxValue = 99;

const ChestCount: React.FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const { data } = useSelector(select.chestInventory.get);
  const isAuthenticated = useSelector(select.session.isClientAuthenticated);
  const value = data?.availableCount || 0;
  const displayValue = value > maxValue ? maxValue : value;

  useEffect(() => {
    if (!data && isAuthenticated) {
      dispatch.chestInventory.fetchChestInventory();
    }
  }, [isAuthenticated, data, dispatch]);

  return value ? <span>{displayValue}</span> : null;
};

export default ChestCount;
